import axios from 'axios';
import prepareRequestOptions from '../utils/admin-apis.util';

export const getListData = async (params = '', signal = null) => {
  const options = prepareRequestOptions(
    `/admin/channel/genres/list${params}`,
    'GET',
    null,
    true,
    signal
  );

  const response = await axios(options);
  return response.data;
};

export const createNewData = async (payload) => {
  const options = prepareRequestOptions(
    '/admin/channel/genre/create',
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const viewDataById = async (id) => {
  const options = prepareRequestOptions(
    `/admin/channel/genre/${id}/view`,
    'GET',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const updateDataById = async (id, payload) => {
  const options = prepareRequestOptions(
    `/admin/channel/genre/${id}/update`,
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const deleteDataById = async (id) => {
  const options = prepareRequestOptions(
    `/admin/channel/genre/${id}/delete`,
    'DELETE',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const assignChannelsToGenre = async (id, payload) => {
  const options = prepareRequestOptions(
    `/admin/channel/genre/${id}/assign-channels`,
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const getSearchableListData = async () => {
  const options = prepareRequestOptions(
    '/admin/channel/genre/search-list',
    'GET',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const getChannelListByGenreId = async (id) => {
  const options = prepareRequestOptions(
    `/admin/channel/genre/${id}/channel/list`,
    'GET',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};
